import {Hub} from 'yougile-model'
import {useGlobalKeyDown} from '@containers/hooks'
import {ScreencastHandlers, screencastStore} from './screencast-store'

export const useRecordScreencast = (
  handlers: ScreencastHandlers,
  hub?: Hub
): void => {
  useGlobalKeyDown(
    {
      anyKey: e => {
        if (e.alt && e.ctrl && e.code === 'KeyR') {
          hub && void screencastStore.startRecording(handlers, hub)
        }
      }
    },
    [hub?.id]
  )
}
